import React from 'react'
import './momentum-direction.styles.scss';

const ManageMomentumDirection = ({ formData, saveData }) => {

  const directions = [
    {
      value: 'negative',
      label: 'Negative',
      desc: 'Something is taken from the player.',
    },
    {
      value: 'neutral',
      label: 'Neutral',
      desc: 'Nothing is given or taken.',
    },
    {
      value: 'positive',
      label: 'Positive',
      desc: 'The player receives a reward.',
    },
  ];

  return (
    <div className='manage-momentum-direction g-list-item form-section'>
      <h3>Momentum Direction<span className='required'>*</span></h3>
      <hr />
      <p>Choose the effect this Momentum Card has on a player.</p>
      <div className='direction-options'>
        {directions.map(d => (
          <div
            key={d.value}
            className={`direction-option ${d.value}${formData.opt_momentumDirection === d.value ? ' active' : ''}`}
            onClick={() => saveData('opt_momentumDirection', d.value)}
          >
            <div className='direction-label'>{d.label}</div>
            <div className='direction-desc meta'>{d.desc}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ManageMomentumDirection
